import { NetzbetreiberDialogService } from '../netzbetreiber-dialog.service';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { Component, inject } from '@angular/core';
import { OrganisationenExportService } from '../../service/organisation/organisation-export.service';

@Component({
    selector: 'ufla-netzbetreiber-page',
    templateUrl: './netzbetreiber-page.component.html',
    styleUrls: [
        './netzbetreiber-page.component.scss',
    ],
    standalone: false,
})
export class NetzbetreiberPageComponent {
    private netzbetreiberDialogService = inject(NetzbetreiberDialogService);
    private organisationenExportService = inject(OrganisationenExportService);
    authenticationService = inject(AuthenticationService);


    public openNewDialog() {
        this.netzbetreiberDialogService.openDetail({ createNew: true });
    }

    public exportListAsCSV() {
        this.organisationenExportService.exportOrganisationen();
    }

}
